module.exports = __webpack_public_path__ + "static/img/material.24d559a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/material.png
// module id = mD9R
// module chunks = 1